import React, { useEffect, useState } from 'react';
import Pluralize from 'react-pluralize';

const useAccessoryImages = ({ accessory }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (accessory && accessory.images) {
      // Extract existing images from the accessory
      const accessoryImages = accessory.images || [];

      setImages(accessoryImages.map((img) => ({ src: img })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessory]);

  useEffect(() => {
    if (images.length > 0 && !images.some((img) => img.isPrimary)) {
      const newImages = [...images];

      // Mark the first image as primary if it was not previously selected or was removed
      newImages[0].isPrimary = true;

      setImages(newImages);
    }
  }, [images]);

  const addImage = (image) => {
    setImages([...images, image]);
  };

  const setPrimaryImage = (primaryIdx) => {
    const newImages = [...images].map((img, idx) => ({
      ...img,
      isPrimary: idx === primaryIdx,
    }));
    setImages(newImages);
  };

  const removeImage = (idx) => {
    const newImages = [...images];
    newImages.splice(idx, 1);
    setImages(newImages);
  };

  function AccessoryImages() {
    return (
      <div>
        <h4>
          {accessory.name} has{' '}
          <Pluralize singular="image" count={images.length} />
        </h4>
        <div className="text-right">
          <label className="btn btn-primary">
            Add New Image
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const reader = new FileReader();
                const [file] = e.target.files;

                reader.onload = (event) =>
                  addImage({ file, src: event.target.result });

                reader.readAsDataURL(file);
                e.target.value = null;
              }}
            />
          </label>
        </div>
        <div className="accessory-images">
          {images.map((img, idx) => (
            <div
              className="accessory-image-card"
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
            >
              <div className="accessory-image-wrapper">
                <img
                  className="accessory-image"
                  src={img.src}
                  alt="accessory"
                />
              </div>
              <div className="accessory-image-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={img.isPrimary}
                  onClick={() => setPrimaryImage(idx)}
                >
                  {img.isPrimary ? 'Primary Image' : 'Make Primary'}
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => removeImage(idx)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return [images, AccessoryImages];
};

export default useAccessoryImages;
